// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
    getAuth,
    connectAuthEmulator,
    setPersistence,
    browserLocalPersistence, // default
    browserSessionPersistence, // good for banking
    inMemoryPersistence // super secure
} from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import {
    initializeFirestore,
    getFirestore,
    connectFirestoreEmulator
} from "firebase/firestore";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getMessaging, onMessage } from "firebase/messaging";
import { getRemoteConfig } from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { isDesktop } from "./components/global";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCq_AYmrbkB4VromUVhAnqXkuY7iAQD9Fs",
    authDomain: "me-heartbank.firebaseapp.com",
    projectId: "me-heartbank",
    databaseURL: "https://me-heartbank-default-rtdb.firebaseio.com",
    databaseURL2:
        process.env.NODE_ENV === "production"
            ? "https://me-heartbank-default-rtdb.firebaseio.com"
            : "http://127.0.0.1:9000/?ns=me-heartbank",
    storageBucket: "me-heartbank.firebasestorage.app",
    messagingSenderId: "591045513975",
    appId: "1:591045513975:web:b6fca2f3604c37fa96b9f2",
    measurementId: "G-1V0H5DVTD3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const fs = getFirestore(app); // "us-central1" is the default region
// export const fs = initializeFirestore(app, {
//     experimentalForceLongPolling: true
// });
export const db = getDatabase(app);
export const functions = getFunctions(app); // "us-central1" is the default region
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);
export const remoteConfig = getRemoteConfig(app); //TODO: later
//setPersistence(auth, browserLocalPersistence); // weird bug: auth state won't update after email link login!

// ipconfig getifaddr en0 => 192.168.1.28
// command D until all is selected

// Connect to emulators (only in development/testing environment)
if (process.env.NODE_ENV !== "production") {
    // Authentication Emulator (default port: 9099)
    connectAuthEmulator(auth, "http://127.0.0.1:9099", {
        disableWarnings: true
    });

    // Functions Emulator (default port: 5001)
    connectFunctionsEmulator(functions, "127.0.0.1", 5001); // localhost = causes 10 second timeout

    // Firestore Emulator (default port: 8080)
    connectFirestoreEmulator(fs, "127.0.0.1", 8081);

    // Firestore Emulator (default port: 9000)
    connectDatabaseEmulator(db, "127.0.0.1", 9000);

    //connect storage emulator (default port: 9199)
    connectStorageEmulator(storage, "127.0.0.1", 9199);
}

onMessage(messaging, (payload) => {
    console.log("Message received in foreground: ", payload);
    // if (isDesktop) // Browsers won't show a banner, so you have to trigger one manually:
    new Notification(
        payload.data?.title || payload.notification?.title || "HeartBank®",
        {
            body:
                payload.data?.body ||
                payload.notification?.body ||
                "Thank with HeartBank®",
            icon:
                payload.data?.image ||
                payload.data?.icon ||
                "https://raw.githubusercontent.com/333eco/stock.333.eco/main/b.gold.svg"
        }
    );
});
